import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import moment from "moment";
import Header from "../../components/Header.vue";
import YearComponent from "../../components/YearComponent.vue";
import {fetchYears} from "../../utils/fetchYears";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)
// import moment from 'moment'

export default {
    components: {
        YearComponent,
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function() {
        return {
            pageTitle: "Liste des tresoreries",
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            dateOptionsDocumentAssocie: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                widgetPositioning: {
                    horizontal: 'right',
                    vertical: 'auto',
                },
            },
            initialPage: parseInt(this.$route.query.page) > 0 ? parseInt(this.$route.query.page) : 1,
            listYear: [],
            vuetable: {
                moreParams: {
                    critere_date:'',
                    date_debut:'',
                    date_fin:'',
                    year: '',
                },
                fields: [
                    // {
                    //     name: VuetableFieldCheckbox,
                    //     titleClass: 'text-center',
                    //     dataClass: 'text-center'
                    // },
                    {
                        name: 'ouverture_date_dossier_formatted',
                        title: 'Date',
                        sortField: 'ouverture_date_dossier_formatted',
                        dataClass: 'text-left',
                        width: '150px'
                    },
                    {
                        name: 'numero_repertoire',
                        title: 'N° Repertoire',
                        sortField: 'numero_repertoire',
                        dataClass: 'text-center'
                    },
                    {
                        name: 'ouverture_bl_numero',
                        title: 'N° BL',
                        sortField: 'ouverture_bl_numero',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'etat_dossier',
                        title: 'Statut',
                        titleClass: 'text-center',
                        width: "110px",
                        dataClass: "text-left"
                    },
                    {
                        name: 'nom_client',
                        title: 'Client',
                        sortField: 'nom_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'ouverture_navire',
                        title: 'Navire',
                        sortField: 'ouverture_navire',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'ouverture_date_arriver',
                        title: 'Date d\'arriver',
                        sortField: 'ouverture_date_arriver',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'declaration_declaration',
                        title: 'N° Declaration',
                        sortField: 'declaration_declaration',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'total_tc',
                        title: 'Nbre TC',
                        sortField: 'total_tc',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'liquidation',
                        title: 'N° Liquidation',
                        sortField: 'liquidation',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'liquidation_date_liquidation_formatted',
                        title: 'Date Liquidation',
                        sortField: 'liquidation_date_liquidation_formatted',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'marchandise',
                        title: 'Marchandise',
                        sortField: 'marchandise',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'total_solde',
                        title: 'Solde',
                        sortField: 'total_solde',
                        width: '120px',
                        dataClass: 'text-right',
                    },

                    {
                        name: 'actions',
                        title: '-',
                        titleClass: 'text-center column_fixed-header',
                        width: "80px",
                        dataClass: "text-center column_fixed"
                    }

                ],
                sortOrder: [
                    { field: 'ouverture_date_dossier', direction: 'desc' }
                ],
                css: {
                    table: {
                        // tableClass: 'table table-striped table-bordered table-hovered',
                        tableClass: 'table-responsive w-100 d-block d-md-table table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'fas fa-arrow-up fa-sm',
                        descendingIcon: 'fas fa-arrow-down fa-sm',
                        handleIcon: 'fas fa-bars fa-sm',
                    },
                    pagination: {
                        infoClass: 'pull-left ',
                        wrapperClass: 'vuetable-pagination text-center custom-pagination',
                        activeClass: 'btn-secondary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: 'fa fa-angle-double-left pagination-icon',
                            prev: 'fa fa-angle-left pagination-icon',
                            next: 'fa fa-angle-right pagination-icon',
                            last: 'fa fa-angle-double-right pagination-icon',
                        },
                    }
                },
            },
            exportexcel: {
                json_fields: {
                    'Nom de la Tresorerie': 'libelle_ecoterme',
                    'Type de la Tresorerie': 'type_tresorerie',
                    'Solde': 'solde',
                    'Nom du compte': 'nom_compte',
                    'Numero du compte': 'numero_compte',
                    'BIC': 'bic',
                    'IBAN': 'iban',
                    'BANQUE Correspondante': 'banque_correspondante',
                    'Code swift': 'code_swift',
                    'Utilisateur associé': 'nom'

                },
                json_data: [],
                json_meta: [
                    [{
                        'key': 'charset',
                        'value': 'utf-8'
                    }]
                ],
            },
            motCle: "",
            crudform: {
                id: "",
                libelle_ecoterme: "",
            },
            crudmodaltitle: "Solder",
            edit_date_arriver: '',
            crudDateArriver: {
                date_arriver: '',
                dossier_id: '',
                date_liquidation:'',
                liquidation: ''
            },
            crudFranchise:[{
                id:'',
                id_compagnie:'',
                ordre:'',
                libeller_franchise:'',
                nbre_jour:0,
                libelle_ecoterme:'',
                tarif:0,
            }],
            btn_submit:false,
            criteriacol:'',
            filtre_etat:'',
            filtre:{
                date_debut:'',
                date_fin:'',
                year: '',
            },
            crudSolde:{
                id:'',
                id_dossier:'',
                id_tresorerie:'',
                date_tresorerie:'',
                date_tresorerie_formatted:'',
                libeller:'',
                montant_credit: 0,
                montant_debit:0,
            },
            liste_tresorerie:[],
            type_modal: 'edit_date_arriver',
            crudDocumentAssocie: [],
            document_associe_dossier_id: ''
        }
    },

    methods: {
        selectYear(year){
          this.filtre.year = year;
            this.setFilter();
            // this.$refs.yearComponent.closeModalYear();
        },
        changerEtatDossier(rowData) {
            axios.get(this.BASE_URL + "/dossier/changeetatdossier/"+rowData.id).then(response => {
                console.log(response);
                Vue.$toast.open({
                    message: response.data.msg,
                    type: 'success',
                    position: 'top-right'
                    // all of other options may go here
                });
                Vue.nextTick(() => this.$refs.vuetable.refresh());

            });
        },
        onRowClass(dataItem, index) {
            if (index == "") console.log("");
            return (parseFloat(dataItem.etat_dossier) > 0 && parseFloat(dataItem.total_solde) <0 ) ? 'bg_cloturer-danger' : (parseFloat(dataItem.etat_dossier) > 0 && parseFloat(dataItem.total_solde) >=0 ) ? 'bg_cloturer' : (parseFloat(dataItem.total_solde) < 0) ? 'text-danger' : '' ;
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.syncFiltersToUrl(paginationData.current_page);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        editRow(rowData) {

            this.$router.push("/dossier/edit/"+rowData.id);
        },
        gotoSuivieDossier(rowData){
            this.$router.push("/dossier/suivi/"+rowData.id);
        },
        editDateArriver(rowData) {
            this.crudDateArriver.dossier_id = rowData.id;
            this.openModalDate()
            this.type_modal = 'edit_date_arriver';
        },
        handleLiquidation(rowData){
            this.crudDateArriver.dossier_id = rowData.id;
            this.openModalDate();
            this.type_modal = 'handle_liquidation';
        },
        downloadZip(rowData){
            window.open(this.BASE_URL + "/dossier/downloadzip/" + rowData.id, '_blank');
        },
        deleteRow(rowData) {
            //alert("You clicked delete on" + JSON.stringify(rowData));
            var that = this;
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        axios.post(that.BASE_URL + "/dossier/delete/" + rowData.id).then(function(response) {
                            console.log(response);
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log(response.data.message);
                                that.setFilter();
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })

        },

        getTresorerie() {
            axios.get(this.BASE_URL + '/tresoreries/getalltresorerie').then((response) => {
                this.liste_tresorerie = response.data;
            })
        },

        Solder(rowData) {
            axios.get(this.BASE_URL+'/dossier/getelementtresorerie/'+rowData.id).then((response)=>{
                this.crudSolde = response.data.data;
                this.getTresorerie();
                this.crudSolde.date_tresorerie_formatted = moment().format('DD/MM/YYYY');
                this.openModal()
            })
        },

        documentAssocie(rowData) {
            console.log(rowData)
            var that = this;
            this.document_associe_dossier_id = rowData.id;
            axios.get(this.BASE_URL + '/dossierdocumentassocier/getdocumentassocie/' + rowData.id).then((response) => {
                that.crudDocumentAssocie = response.data.map(function(doc) {
                    return {
                        id: doc.id,
                        id_dossier: rowData.id,
                        nom_document: doc.nom_document,
                        is_document: doc.is_document,
                        statut: doc.statut,
                        date_reception: doc.date_reception ? moment(doc.date_reception).format('DD/MM/YYYY') : ''
                    };
                });
                that.openModalDocumentAssocie();
            });
        },
        saveDocumentAssocier() {
            var that = this;
            this.btn_submit = true;
            var payload = {
                id_dossier: this.document_associe_dossier_id,
                documents: this.crudDocumentAssocie
            };
            axios.post(this.BASE_URL + '/dossierdocumentassocier/savedocumentassocie', payload).then(function(response) {
                that.btn_submit = false;
                if (response.data.error === "") {
                    that.closeModalDocumentAssocie();
                    Vue.$toast.open({
                        message: response.data.message,
                        type: 'success',
                        position: 'top-right'
                    });
                } else {
                    Vue.$toast.open({
                        message: response.data.error,
                        type: 'error',
                        position: 'top-right'
                    });
                }
            });
        },
        onLoading() {
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },
        applyFiltersToParams() {
            this.vuetable.moreParams.filter = this.motCle;
            this.vuetable.moreParams.criteriacol = this.criteriacol;
            this.vuetable.moreParams.filtre_etat = this.filtre_etat;
            this.vuetable.moreParams.year = this.filtre.year;

            this.vuetable.moreParams.critere_date = (this.filtre.date_fin !="" || this.filtre.date_debut !="") ? "ouverture_date_arriver" : "";
            this.vuetable.moreParams.date_fin = (this.filtre.date_fin !="") ? this.filtre.date_fin : "";
            this.vuetable.moreParams.date_debut = (this.filtre.date_debut !="") ? this.filtre.date_debut : "";
        },
        syncFiltersToUrl(currentPage) {
            const query = {};
            if (this.motCle !== "") query.filter = this.motCle;
            if (this.criteriacol !== "") query.criteriacol = this.criteriacol;
            if (this.filtre_etat !== "") query.filtre_etat = this.filtre_etat;
            if (this.filtre.year !== "") query.year = this.filtre.year;
            if (this.filtre.date_debut !== "") query.date_debut = this.filtre.date_debut;
            if (this.filtre.date_fin !== "") query.date_fin = this.filtre.date_fin;
            if (parseInt(currentPage) > 1) query.page = String(currentPage);

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({ query }).catch(() => {});
            }
        },
        setFilter() {
            this.applyFiltersToParams();

            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        resetFilter() {
            this.motCle = "";
            this.criteriacol = "";
            this.filtre_etat = "";
            this.filtre={
                date_debut: '',
                date_fin:'',
                year: '',
            }

            this.setFilter();
        },
        onExport() {

            this.exportexcel.json_data = this.$refs.vuetable.$data.tableData;
            $("#excel-download").trigger("click");
        },
        openModal() {
            this.$bvModal.show("crudmodal");
        },
        closeModal() {
            this.$bvModal.hide("crudmodal");
        },

        openModalDate() {
            this.$bvModal.show("editDate");
        },
        closeModalDate() {
            this.$bvModal.hide("editDate");
        },
        openModalDocumentAssocie() {
            this.$bvModal.show("documentAssocieModal");
        },
        closeModalDocumentAssocie() {
            this.$bvModal.hide("documentAssocieModal");
        },
        addRow() {
            this.crudmodaltitle = "Nouveau ecoterme";
            this.crudform = {
                id: "",
                libelle_ecoterme: "",
            };
            // console.log(this.crudform);
            this.openModal();
        },

        saveDateArriver() {
            var that = this;
            const link = this.type_modal !== 'handle_liquidation' ? that.BASE_URL + "/dossier/savedatearriver" : that.BASE_URL + "/dossier/handleliquidation";
            axios.post(link, $("#formulaireSaveDate").serialize()).then((response) => {
                that.btn_submit = false;
                if (response.data.cle === "") {
                    that.closeModalDate();
                    Vue.$toast.open({
                        message: response.data.message,
                        type: 'success',
                        position: 'top-right'
                    });
                    Vue.nextTick(() => this.$refs.vuetable.refresh());

                } else {
                    console.log("Erreur");
                    Vue.$toast.open({
                        message: response.data.cle,
                        type: 'error',
                        position: 'top-right'
                    });
                }
            });
        },

        onSubmit() {
            var that = this;

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment continuer l\'enregistrement?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Continuer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        var link = '';
                        that.btn_submit = true;

                        link = that.BASE_URL + "/dossier/reglementsolde" ;

                        axios.post(link, $("#formulaire").serialize()).then(function(response) {
                            console.log(response);
                            that.btn_submit = false;
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log("Enregistrement effectué avec succès!");
                                that.closeModal();
                                that.setFilter();
                                Vue.$toast.open({
                                    message: 'Enregistrement effectué avec succès!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                });
        },
        fetchData: function() {
            axios.get(this.BASE_URL + "/tresoreries/fetchdata").then(response => {
                console.log(response)
                this.listdata = response.data;
            });
        },

        async fetchYear() {
            const response = await fetchYears({that: this, link: '/dossier/fetchyear'})
            this.listYear = response.data;
        },

    },

    created: async function() {
        this.$emit('change-page', this.pageTitle);
        const query = this.$route.query;
        this.motCle = query.filter || "";
        this.criteriacol = query.criteriacol || "";
        this.filtre_etat = query.filtre_etat || "";
        this.filtre = {
            date_debut: query.date_debut || "",
            date_fin: query.date_fin || "",
            year: query.year || "",
        };
        this.applyFiltersToParams();
        await this.fetchYear();
    },
    mounted: function() {

    }
}
